<app-breadcrumbs></app-breadcrumbs>
<div class="onboard-wrap buywifi-bgcolor">
    <div class="confirmation-wrapper">
        <section class="onboard-payment-success">
            <div>
                <div class="conf-success-icon">
                    <svg class="check-circle-icon" role="presentation">
            <use xlink:href="#cl--check" href="#cl--check"></use>
          </svg>
                </div>
                <div class="payment-sucess">
                    <h2>{{'paymentSuccess' | translate}}</h2>
                </div>
            </div>

        </section>
        <section class="buy-wifi-product wrapper text-white confirm-page">
            <div class="outbound-trip-details outbound-wifi-confirm">
                <div class="wifi-ond-details ond-detail">
                    <div class="wifi-origin-wrapper" *ngIf="!showEBforPointsBuy">
                        <div class="wifi-origin-name">{{currentSegment.departureAirport.name}}</div>
                        <div class="wifi-origin-code mrgn-l-5">
                            <span>{{currentSegment.departureAirport.code}}</span>
                        </div>
                    </div>
                    <div class="wifi-destination-wrapper" *ngIf="!showEBforPointsBuy">
                        <span class="mrgn-l-5">-</span>
                        <div class="wifi-destination-name mrgn-l-5">{{currentSegment.arrivalAirport.name}}</div>
                        <div class="wifi-destination-code mrgn-l-5">
                            <span>{{currentSegment.arrivalAirport.code}}</span>
                        </div>
                    </div>
                    <div class="wifi-origin-wrapper" *ngIf="showEBforPointsBuy">
                        <div class="wifi-origin-name">{{origin.name}}</div>
                        <div class="wifi-origin-code mrgn-l-5">
                            <span>{{origin.iataCode}}</span>
                        </div>
                    </div>
                    <div class="wifi-destination-wrapper" *ngIf="showEBforPointsBuy">
                        <span class="mrgn-l-5">-</span>
                        <div class="wifi-destination-name mrgn-l-5">{{destination.name}}</div>
                        <div class="wifi-destination-code mrgn-l-5">
                            <span>{{destination.iataCode}}</span>
                        </div>
                    </div>
                </div>
                <div class="col large-12 medium-12 small-12">
                    <div class="connect-wifi-button-wrap col large-6 medium-6 small-12">
                        <div class="traveler-wifi-info confirm-wifi-info center-text-align">
                            <div class="large-12 medium-12 small-12">
                                <svg class="device-icon" role="presentation">
                  <use xlink:href="#cl--device" href="#cl--device"></use>
                </svg>
                            </div>
                            <div class="connect-text large-12 medium-12 small-12 ">
                                {{'startSurfing' | translate}}
                            </div>
                            <button class="btn medium primary pad-b-10" tabindex="0" id="startsurf-btn" (click)="startSurfing();">
                {{'startSuring.button' | translate}}
              </button>
                        </div>
                    </div>
                    <div class="passenger-confirm-wrap large-6 medium-6 small-12">
                        <div class="traveler-wifi-info center-text-align text-pad-l">
                            <div class="col large-6 medium-6 small-12 pad-l-0">
                                <svg class="devices-icon" role="presentation">
                  <use xlink:href="#cl--devices" href="#cl--devices"></use>
                </svg>
                                <div class="connect-long-text large-12 medium-12 small-12">
                                    <span *ngIf="isCharter" [innerHtml]="'connectMoreDevices.charter' | translate"></span>
                                    <span *ngIf="!isCharter" [innerHtml]="'connectMoreDevices' | translate"></span>
                                </div>
                            </div>
                            <div class="confirm-name col large-6 medium-6 small-12 ">
                                <div class="large-12 medium-12 small-12 passenger-det-small-txt">
                                    <span *ngIf="isCharter">{{'conf.email' | translate}}</span>
                                    <span *ngIf="!isCharter">{{'connectedPnr' | translate}}</span>
                                </div>
                                <div class="large-12 medium-12 small-12 passenger-det">
                                    <strong class="text-small" *ngIf="isCharter">{{passengerDetails.email}}</strong>
                                    <strong *ngIf="!isCharter">{{passengerDetails.bookingReference}}</strong>                                
                                </div>
                                <div class="large-12 medium-12 small-12 passenger-det-small-txt">
                                    {{'connectedName' | translate}}
                                </div>
                                <div class="large-12 medium-12 small-12 passenger-det">
                                    <strong class="text-small text-capt" *ngIf="isCharter">{{passengerDetails.firstname}} {{passengerDetails.secondname}}</strong>
                                    <strong *ngIf="!isCharter">{{passengerDetails.firstName}} {{passengerDetails.lastName}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="receipt-wifi-wrap confirm-receipt-info">
                    <div class="payment-wifi-info">
                        <div class="confirm-receipt large-12 medium-12 small-12">
                            <div class="col large-12 medium-12 small-12">
                                <strong class="pay-infodetail">{{'paymentDetails' | translate }}</strong>
                            </div>
                            <div class="col large-12 medium-12 small-12 confirm-pad">
                                <div class="col large-3 medium-3 small-6 pad-l-0">
                                    <div class="confirm-txt-clr confirm-txt-key" *ngIf="wifiKey > 1">{{'sasWifiAccess' | translate }} {{wifiKey}} {{'devices' | translate }}</div>
                                    <div class="confirm-txt-clr confirm-txt-key" *ngIf="wifiKey === 1">{{'sasWifiAccess' | translate }} {{wifiKey}} {{'device' | translate }}</div>
                                </div>
                                <div class="col large-9 medium-9 small-6 pad-l-0 confirm-txt-clr m-rgt-align" *ngIf="!showEBforPointsBuy">
                                    {{wifiKey}} X {{price | formatPrice:true:true:'no' }}
                                </div>
                                <div class="col large-9 medium-9 small-6 pad-l-0 confirm-txt-clr m-rgt-align" *ngIf="showEBforPointsBuy">
                                    {{wifiKey}} X {{price}}
                                </div>
                            </div>
                            <div id="total-price" class="col large-12 medium-12 small-12 price-det" tabindex="0" [attr.aria-label]="(wifiKey * price) | formatPrice:true:true:'no'" *ngIf="!showEBforPointsBuy">
                                <div>
                                    <strong>{{wifiKey * price | formatPrice:true:true:'no' }}</strong>
                                </div>
                            </div>
                            <div id="total-price" class="col large-12 medium-12 small-12 price-det" tabindex="0" [attr.aria-label]="(wifiKey * price)" *ngIf="showEBforPointsBuy">
                                <div>
                                    <strong>{{wifiKey * price}} {{'pointsText' | translate }}</strong>
                                </div>
                            </div>

                            <div class="col large-12 medium-12 small-12 rgt-align confirm-txt-clr" *ngIf="!showEBforPointsBuy">
                                <div class="tax-row">{{'cart.taxIncluded' | translate }} {{wifiKey * price | formatPrice:true:true:'no' }}</div>
                            </div>
                            <div class="col large-12 medium-12 small-12">
                                <div class="border-btm"></div>
                            </div>
                            <div class="col large-12 medium-12 small-12 rgt-align small-txt confirm-txt-clr">
                                <div>{{'wifi.recep' | translate }} {{receiptEmailAddress}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
<app-footer></app-footer>